const env = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiUrlNext: process.env.REACT_APP_API_URL_NEXT,
};

export default env;
